// extracted by mini-css-extract-plugin
export default {"wrapper":"X1-z","play":"Y1-z"};